export const FY_YEAR_OPTIONS = [
  { label: "2026-2027", value: "2026" },
  { label: "2025-2026", value: "2025" },
  { label: "2024-2025", value: "2024" },
  { label: "2023-2024", value: "2023" },
];
